import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
  isError?: boolean;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, isError, ...props }, ref) => {
    const hasError = !!error || isError;

    return (
      <div className="flex size-full flex-col">
        <textarea
          className={cn(
            'flex w-full rounded-sm border border-solid border-border bg-white px-3 py-2 text-sm leading-[170%] placeholder:text-gray-500 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary disabled:cursor-not-allowed disabled:opacity-50',
            !className?.includes('h-') && !className?.includes('min-h-') && 'min-h-[80px]',
            hasError && 'border-danger focus:outline-danger',
            className
          )}
          ref={ref}
          {...props}
        />
        {error && <p className="mt-1 text-sm text-danger">{error}</p>}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';

export { Textarea };
